// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Move } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMove(props: any) {
    return <IconBase icon={Move} {...props} />
  }

  export default IconMove
  